import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-lib-ff-button',
  styleUrls: ['./button.component.scss'],
  templateUrl: './button.component.html',
})
export class FormlyButtonComponent extends FieldType {}
